import React from 'react'
import { IconProps } from '../../../common/types'

const PayrollIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15 2.688c5 0 7 2 7 7v6c0 5-2 7-7 7H9c-5 0-7-2-7-7v-6c0-5 2-7 7-7zM8.57 15.958l6.54-6.54"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M8.98 11.058a1.23 1.23 0 1 1 0-2.46 1.23 1.23 0 0 1 0 2.46M15.52 16.777a1.23 1.23 0 1 1 0-2.46 1.23 1.23 0 0 1 0 2.46"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default PayrollIcon
